export default {
  'menu.welcome': 'Welcome',
  'menu.dashboard': 'Statistics',
  'menu.search': 'Search',
  'menu.showcase': 'ShowCase',
  'menu.showcase.list': 'Case List',
  'menu.showcase.create': 'Create Case',
  'menu.showcase.edit': 'Edit Case',
  'menu.showcase.detail': 'Case Detail',
  'menu.category': 'Categories',
  'menu.showcase.category': 'Categories',
  'menu.customerShare': 'Customer Share Management',
  'menu.customerShare.list': 'Share List',
  'menu.customerShare.create': 'Create Share',
  'menu.customerShare.edit': 'Edit Share',
  'menu.showcase.customerShare': 'Customer Share',
  'menu.showcase.customerShare.list': 'Share List',
  'menu.showcase.customerShare.create': 'Create Share',
  'menu.showcase.customerShare.edit': 'Edit Share',
  // Documentation Management
  'menu.docManagement': 'Documentation',
  'menu.docManagement.groups': 'Doc Groups',
  'menu.docManagement.createGroup': 'Create Doc Group',
  'menu.docManagement.editGroup': 'Edit Doc Group',
  'menu.docManagement.standaloneDocs': 'Documents',
  'menu.docManagement.editStandaloneDoc': 'Edit Document',
  'menu.docManagement.createStandaloneDoc': 'Create Document',
  'menu.docManagement.documents': 'Group Documents',
  'menu.docManagement.createDocument': 'Create Document',
  'menu.docManagement.editDocument': 'Edit Document',
  'menu.docManagement.trash': 'Document Trash',
  'menu.docManagement.trashDetail': 'Document Trash',
  'menu.docManagement.apiKeys': 'API Key Management',
  'menu.docManagement.apiKeyLogs': 'API Key Logs',
  'menu.team': 'Team',
  'menu.team.detail': 'Team Detail',
  'menu.settings': 'Settings',
  'menu.settings.basic': 'Basic Settings',
  'menu.agent': 'Agent Intelligence',
  'menu.agent.health': 'Doc Health',
  'menu.agent.suggestions': 'AI Suggestions',
  'menu.agent.config': 'Policy Config',
  'menu.agent.audit': 'Audit Log',
  'menu.agent.tokenUsage': 'Token Usage',
  'menu.agent.memory': 'Memory Management',
  'menu.agent.conversationLogs': 'Conversation Logs',
  'menu.agent.llmProviders': 'LLM Providers',
  'menu.admin': 'Admin',
  'menu.admin.users': 'User Management',
  'menu.admin.roles': 'Role Management',
  'menu.admin.menus': 'Menu Management',
  'menu.admin.appVersions': 'App Versions',
  'menu.admin.dataPermissions': 'Data Permissions',
  'menu.admin.systemStats': 'Usage Statistics',
  'menu.login': 'Login',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
};
